import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import api from '@/helpers/fetch'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faFilePdf } from '@fortawesome/free-solid-svg-icons'

import Podcasts from './Podcasts/index.vue'
import Laminas from './Laminas/index.vue'

library.add(faFilePdf)

@Component({
	components: {
		Loader,
		vSelect,
		Podcasts,
		Laminas,
	},
})
export default class Browse extends Vue {
	blogPosts = [] as Array<any>
	loadCount = 0
	loadingBlog = true
	loading = true
	filters = {
		tags: [] as Array<any>,
		title: '',
	}

	options = {
		tags: [] as Array<any>,
	}

	get selectedWPIDTags() {
		return this.options.tags.reduce((wpTags, tag) => {
			const found = this.filters.tags.filter((id) => tag.id === id)

			if (found.length > 0) {
				wpTags.push(tag.wp_id)
			}

			return wpTags
		}, [])
	}

	search() {
		if (this.filters.tags.length <= 0 && !this.filters.title) {
			this.$bvToast.toast(
				'Adicione uma tag ou digite algum termo para pesquisa',
				{
					title: 'Ops...',
					variant: 'warning',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
			return
		}

		this.$router.push({
			query: { tags: this.filters.tags, title: this.filters.title },
		})
		this.loadCount++
		this.loadBlogPosts()
	}

	clearForm() {
		this.filters.title = ''
		this.filters.tags = []
	}

	openLink(url) {
		window.open(url, '_blank')
	}

	loadBlogPosts() {
		this.loadingBlog = true
		this.blogPosts.length = 0
		const params = [
			'per_page=50',
			'status=publish',
			'categories=3',
			'context=embed',
		]

		if (this.selectedWPIDTags.length > 0) {
			params.push('tags=' + this.selectedWPIDTags.join(','))
		}

		if (this.filters.title) {
			params.push('search=' + this.filters.title)
			params.push('search_columns=post_title')
		}

		const url =
			'https://locatelliadv.com.br/wp-json/wp/v2/posts?' +
			params.join('&')

		fetch(url, {
			method: 'GET',
			headers: {
				Authorization:
					'Basic YWRtaW4ubGxhYzpkcURhIGNVRkkgUkJLUiBsbGdxIHpHNUMgb054Zw==',
			},
		})
			.then((response) => response.json())
			.then((data) => {
				data.forEach((item) => {
					const post = {
						date: new Intl.DateTimeFormat('pt-BR').format(
							new Date(item.date),
						),
						text: item.excerpt.rendered,
						link: item.link,
						title: item.title.rendered,
						image: item.jetpack_featured_media_url,
					}

					this.blogPosts.push(post)
				})

				this.loadingBlog = false
			})
	}

	async loadContentTags() {
		this.loading = true
		const res = await api.get('/api/blogging/content-tags')
		this.loading = false
		this.options.tags.length = 0
		this.options.tags = res.data
	}

	async mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		await this.loadContentTags()

		await this.$nextTick()
		if (this.$route.query.tags) {
			if (Array.isArray(this.$route.query.tags)) {
				this.filters.tags.length = 0
				this.filters.tags.push(
					...this.$route.query.tags.map((tag) => parseInt(tag!)),
				)
			} else {
				this.filters.tags = [parseInt(this.$route.query.tags)]
			}
		}
		if (this.$route.query.title) {
			this.filters.title = this.$route.query.title as string
		}

		// atualiza componentes filhos apos carregar a pagina
		if (this.$route.query.title || this.$route.query.tags) {
			this.loadCount++
		}

		this.loadBlogPosts()
	}
}
